"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DataLinksCreativeBriefsModal;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function DataLinksCreativeBriefsModal(_ref) {
  var selectedPersonas = _ref.selectedPersonas,
      segmentType = _ref.segmentType,
      currentDataPage = _ref.currentDataPage;

  var _useState = (0, _react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var personaIdsArray = selectedPersonas.map(function (persona) {
    return persona.id;
  });
  var creativeBriefsDisabled = segmentType !== 'segments';
  var universeId = (0, _reactRedux.useSelector)(function (state) {
    return state.universes.currentUniverse;
  });
  var selectedCharacteristics = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedCharacteristics.characteristics;
  });
  var personaRecords = (0, _reactRedux.useSelector)(function (state) {
    return state.findPersonasIndividual.records;
  });

  var _useState2 = (0, _react.useState)(0),
      selectedCharacteristic = _useState2[0],
      setSelectedCharacteristic = _useState2[1];

  var creativeBriefsLink = function creativeBriefsLink(selectedCharacteristic) {
    var filteredRecords = personaRecords.filter(function (record) {
      return record.answerId === selectedCharacteristic && personaIdsArray.includes(record.segmentId);
    });
    var totalShareAmount = filteredRecords.reduce(function (total, record) {
      return total += record.shareOfProperty;
    }, 0);
    var queryStringRecords = filteredRecords.map(function (record) {
      return record.segmentId + ":" + 100 / totalShareAmount * record.shareOfProperty;
    }).join(',');
    return "creative-briefs/message-streams?personaShares=" + queryStringRecords + "&universeId=" + universeId;
  };

  var handleCreativeBriefsClick = function handleCreativeBriefsClick() {
    if (selectedCharacteristics.length === 1) {
      window.open(creativeBriefsLink(Number(selectedCharacteristics[0].answerId)), '_blank');
    } else {
      setOpen(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    as: "a",
    className: "no-underline text button-as-link",
    onClick: function onClick() {
      return handleCreativeBriefsClick();
    },
    disabled: creativeBriefsDisabled || !selectedCharacteristics.length || !selectedPersonas.length
  }, "Send selected personas to Creative Briefs"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
    className: "data-linking__to-cb-modal",
    onClose: function onClose() {
      return setOpen(false);
    },
    open: open,
    closeOnEscape: true,
    closeOnDimmerClick: true,
    closeIcon: /*#__PURE__*/_react["default"].createElement("button", {
      className: "modal__close"
    })
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, null, "Creative Briefs Selection"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, {
    className: "data-linking__to-cb-modal-content"
  }, selectedCharacteristics.length ? selectedCharacteristics.map(function (_ref2) {
    var answerLabel = _ref2.answerLabel,
        answerId = _ref2.answerId;
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Checkbox, {
      className: "data-linking__to-cb-radio",
      key: answerId,
      radio: true,
      label: answerLabel,
      value: answerId,
      onClick: function onClick(e, data) {
        return setSelectedCharacteristic(Number(answerId));
      },
      checked: selectedCharacteristic === answerId
    });
  }) : null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "data-linking__to-cb-button",
    as: _reactRouterDom.Link,
    to: creativeBriefsLink(selectedCharacteristic),
    target: "_blank",
    disabled: !selectedCharacteristic,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, "Go to Creative Briefs"))));
}